import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';

import type { ResponseError } from '../../types';
import type { TwoFactorFormDataType } from './types';

export const initialState = {
    loading: false,
    formData: {
        code: '',
    },
    error: <ResponseError | null>null,
};

const twoFactorSlice = createSlice({
    name: 'signup',
    initialState,
    reducers: {
        setLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.loading = payload;
        },
        setError: (state, { payload }: PayloadAction<ResponseError | null>) => {
            state.error = payload;
        },
        updateFormData: (state, { payload }: PayloadAction<TwoFactorFormDataType>) => {
            state.formData = {
                ...state.formData,
                ...payload,
            };
        },
    },
});

const twoFactorLogin = createAction('auth/twoFactorLogin');

export default twoFactorSlice.reducer;

const { setLoading, updateFormData, setError } = twoFactorSlice.actions;

export const twoFactorLoginActions = {
    setLoading,
    setError,
    updateFormData,
    twoFactorLogin,
};
